<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  onClicked: {
    type: Function,
    required: true,
  },
  currentSection: {
    type: String,
    default: '',
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  resumeLanguage: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div
    v-if="content.technos"
    class="experience experience-technical-environment"
    :class="content.indentation ? content.indentation : 'none'"
  >
    <div class="date" />
    <div class="timeline no-bullet" />
    <div class="data">
      <div
        :class="{ selected: isSelected && currentSection === 'technos' }"
        class="section technos"
        @click="onClicked('technos')"
      >
        <span class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-technical-environment`) }}</span>
        <div class="items" v-html="content.technos"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  color: var(--color1);
  font-weight: 700;
}

.section,
.date {
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }
}
</style>
